import {ImageOff} from 'lucide-react';
import {useMediaSrc} from '../lib/media';
import type {MediaRef} from '../store/types';

/**
 * Every picture in the product.
 *
 * It always reserves its box before the bytes arrive: a listing grid where the
 * cards grow as their photos load is a grid you cannot click on. `ratio` is a
 * CSS aspect-ratio string so the reservation is exact.
 */
export function Picture({
  alt,
  className = '',
  ratio = '4 / 3',
  refItem,
}: {
  alt: string;
  className?: string;
  ratio?: string;
  refItem: MediaRef | null;
}) {
  const src = useMediaSrc(refItem);

  return (
    <div className={`frame relative ${className}`} style={{aspectRatio: ratio}}>
      {src ? (
        <img src={src} alt={alt} loading="lazy" className="h-full w-full object-cover" />
      ) : refItem ? (
        <div className="h-full w-full animate-pulse bg-[var(--color-sunken)]" />
      ) : (
        <div className="flex h-full w-full items-center justify-center text-ink-3">
          <ImageOff size={22} />
        </div>
      )}
    </div>
  );
}
